<template>
  <div>
    <button
      class="btn action-btn btn--darkblue"
      v-if="isDisplayAdd"
      @click="add"
    >{{ $t('action.add') }}</button>
    <button
      class="btn action-btn btn--orange"
      v-if="isDisplayEdit"
      :disabled="disableEdit"
      @click="edit"
    >{{ $t('action.edit') }}</button>
    <button
      class="btn action-btn btn--darkblue"
      v-if="isDisplayCancel"
      @click="cancel"
    >{{ $t('action.cancel') }}</button>
    <button
      class="btn action-btn btn--orange"
      v-if="isDisplaySave"
      @click="save"
    >{{ $t('action.save') }}</button>
  </div>
</template>
<script>
import container from './container'
export default container
</script>
<style scoped>
.action-btn {
  margin-left: 10px;
  min-width: 30px;
}
</style>
